var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFournisseurs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 125 100",
    style: {
      enableBackground: "new 0 0 125 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EE7203;}\r\n\t.st1{fill:#000000;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#000000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.9,33.3h20.3c0.6,0,1.1,0.5,1.1,1.1s-0.5,1.1-1.1,1.1H4.9c-0.6,0-1.1-0.5-1.1-1.1S4.3,33.3,4.9,33.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.8,56.4h5.3c0.6,0,1.1,0.5,1.1,1.1s-0.5,1.1-1.1,1.1h-5.3c-0.6,0-1.1-0.5-1.1-1.1S19.2,56.4,19.8,56.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.5,44.9h20.3c0.6,0,1.1,0.5,1.1,1.1s-0.5,1.1-1.1,1.1H4.5c-0.6,0-1.1-0.5-1.1-1.1S3.9,44.9,4.5,44.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.4,75.1c0.5,2.4,2.6,4.2,5.1,4.2C55,79.3,52.9,77.5,52.4,75.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.1,39.6H94.4c-0.1,0-0.2-0.1-0.2-0.2V16.6h-57v58.7h12.3c0.1,0,0.2,0.1,0.2,0.2c0.7,3.8,4,6.5,7.8,6.5 c3.8,0,7.1-2.7,7.8-6.5c0-0.1,0.1-0.2,0.2-0.2h28.2c0.1,0,0.2,0.1,0.2,0.2c0.7,3.8,4,6.5,7.8,6.5c3.8,0,7.1-2.7,7.8-6.5 c0-0.1,0.1-0.2,0.2-0.2h12.3V56.3C121.9,46.8,114.7,39.6,105.1,39.6z M57.5,79.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4 s5.4,2.4,5.4,5.4C62.9,77,60.5,79.4,57.5,79.4z M101.6,79.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c3,0,5.4,2.4,5.4,5.4 C107,77,104.6,79.4,101.6,79.4z M119.4,72.6c0,0.1-0.1,0.2-0.2,0.2h-9.6c-0.1,0-0.2-0.1-0.2-0.2c-0.7-3.8-4-6.5-7.8-6.5 c-3.8,0-7.1,2.7-7.8,6.5c0,0.1-0.1,0.2-0.2,0.2H65.5c-0.1,0-0.2-0.1-0.2-0.2c-0.7-3.8-4-6.5-7.8-6.5c-3.8,0-7.1,2.7-7.8,6.5 c0,0.1-0.1,0.2-0.2,0.2H40c-0.1,0-0.2-0.1-0.2-0.2V19.3c0-0.1,0.1-0.2,0.2-0.2h51.6c0.1,0,0.2,0.1,0.2,0.2v33.5h2.5V42.3 c0-0.1,0.1-0.2,0.2-0.2h10.7c8.3,0,14.2,6,14.2,14.2V72.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFournisseurs);
export default __webpack_public_path__ + "static/media/fournisseurs.4565405cbe7f96ba7b580e4d02be2667.svg";
export { ForwardRef as ReactComponent };